// @ts-nocheck
import * as React from "react"
import { useEffect } from 'react'
import anime from "animejs";
import SplitTextHtml from "./SplitTextHtml";
import { useApi } from '../config/state';

export default ({ slideList, slideTitle }: { slideList: Array<HomeSlider>, slideTitle: string }) => {
    const textTitle = SplitTextHtml(slideTitle, 'single', 'word-split-carousel--large')
    // console.log(slideList);
    const {data, fetchHome} = useApi(state => (state))
    
    useEffect(() => {
        fetchHome()
    }, [])
    

    const initCarousel = () => {
        const spaceHolder = document.querySelector('.space-holder');
        const horizontal = document.querySelector('.horizontal');
        spaceHolder.style.height = `${calcDynamicHeight(horizontal)}px`;

        

        function calcDynamicHeight(ref) {
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            const objectWidth = ref.scrollWidth;
            return objectWidth - vw + vh;
        }

        window.addEventListener('scroll', () => {
            const sticky = document.querySelector('.sticky');
            horizontal.style.transform = `translateX(-${sticky.offsetTop}px)`;
        });

        window.addEventListener('resize', () => {
            spaceHolder.style.height = `${calcDynamicHeight(horizontal)}px`;
        });
    }

    const checkImageLoaded = () => {
        let imagesCarousel = document.querySelectorAll("#homeSwiper img")
        let imageCompleted = 0
        imagesCarousel.forEach(image => {
            image.onload = () => {
                imageCompleted++
                if (imageCompleted == imagesCarousel.length) {
                    setTimeout(() => {
                        initCarousel();
                    }, 200)
                }
            }
        })
    }

    React.useEffect(() => {
        checkImageLoaded()
    }, [])

    return (
        <section id="homeSwiper">
            <div className="space-holder">
                <div className="sticky">
                    <div className="horizontal">
                        <section role="feed" className="cards">
                            {slideList.map((slide: HomeSlider, slideIndex: number) => (
                                <div key={slideIndex} className="sample-card">
                                    {slideIndex == 0 && <h3 className='swiper-title' dangerouslySetInnerHTML={{ __html: textTitle }}></h3>}
                                    {slide.field_meta_info && <article className='swiper-description' dangerouslySetInnerHTML={{ __html: SplitTextHtml(slide.field_meta_info, 'advanced') }}></article>}
                                    <picture>
                                        <source media="(min-width: 768px)" srcSet={slide.field_imgdesk.url} />
                                        <img src={slide.field_imgmob.url} alt={slide.field_imgdesk.alt} title={slide.field_imgdesk.alt} />
                                    </picture>
                                </div>
                            ))}
                        </section>
                    </div>
                </div>
            </div>
        </section>
    )
}